// extracted by mini-css-extract-plugin
module.exports = {"primary":"#045bbe","taskCompleted":"EditableOnClick_taskCompleted__2DU0H","pointer":"EditableOnClick_pointer__2PPQ1"};